import React from "react";
import { media, styled } from "@iventis/styles";
import { Select, FormControl } from "@mui/material";
import { Content } from "@iventis/translations/content/typed-content";
import { format } from "date-fns";
import { StyledMenuItem, StyledItemSelect } from "@iventis/components";
import { utcToZonedTime } from "date-fns-tz";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";

export const DaySelector: React.FC<{ onChange: (day: number) => void; dayNumber: number; days: Map<number, Date>; timezone: string; className?: string; disabled?: boolean }> = ({
    onChange,
    dayNumber,
    days,
    timezone,
    className,
    disabled,
}) => {
    if (!days.has(dayNumber)) {
        throw new Error(`Proveded day '${dayNumber}' is not within provided days`);
    }

    const translate = useIventisTranslate();

    return (
        <>
            <FormControl variant="outlined" className={className}>
                <Select
                    data-cy="schedule-day-selector"
                    disabled={disabled}
                    input={<StyledItemSelect $verticalPadding="8px" />}
                    value={dayNumber}
                    renderValue={(value: number) => (
                        <span>
                            <DesktopRender>
                                {`${translate(Content.schedule.day)} ${value} (${format(utcToZonedTime(days.get(value), timezone), "EEE, dd MMM yyyy")})`}
                            </DesktopRender>
                            <MobileRender>{`${translate(Content.schedule.day)} ${value}`}</MobileRender>
                        </span>
                    )}
                    onChange={(e) => onChange(e.target.value as number)}
                >
                    {Array.from(days).map((day) => (
                        <StyledMenuItem data-cy={`schedule-day-${day[0].toString()}`} value={day[0]} key={day[0]}>
                            {day[0]} ({format(utcToZonedTime(day[1], timezone), "EEE, dd MMM yyyy")})
                        </StyledMenuItem>
                    ))}
                </Select>
            </FormControl>
        </>
    );
};

const DesktopRender = styled.div`
    display: block;
    ${media.extraSmall} {
        display: none;
    }
`;

const MobileRender = styled.div`
    display: none;
    ${media.extraSmall} {
        display: block;
    }
`;

export interface ScheduleDay {
    number: number;
}
